import { ButtonProps } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { OrangeButton } from '../OrangeButton/OrangeButton'

export const RegenerateAiButton: React.FC<ButtonProps> = ({
  loading = false,
  disabled,
  className,
  ...props
}) => {
  return (
    <OrangeButton
      className={className}
      loading={loading}
      disabled={disabled}
      icon={!loading ? <ReloadOutlined /> : undefined}
      {...props}
    >
      Перегенерировать
    </OrangeButton>
  )
}
